<template>
  <article class="article-card card" @click="$emit('click')">
    <h3 class="article-card__title">{{ article.title }}</h3>
    <p v-if="excerpt" class="article-card__excerpt">{{ excerpt }}</p>
    <div v-if="hashtags.length" class="article-card__tags">
      <span
        v-for="tag in hashtags"
        :key="tag"
        class="article-card__hashtag"
      >{{ tag }}</span>
    </div>
  </article>
</template>

<script>
export default {
  name: 'ArticleCard',
  props: {
    article: {
      type: Object,
      required: true,
    },
  },
  emits: ['click'],
  computed: {
    excerpt() {
      return (
        this.article?.description ||
        this.article?.content ||
        ''
      ).trim()
    },
    hashtags() {
      const raw = this.article?.tag ?? this.article?.tags
      if (!raw) return []
      if (Array.isArray(raw)) {
        return raw
          .map((s) => String(s).trim())
          .filter(Boolean)
          .map((s) => (s.startsWith('#') ? s : `#${s}`))
      }
      return String(raw)
        .split(/[,，]/)
        .map((s) => s.trim())
        .filter(Boolean)
        .map((s) => (s.startsWith('#') ? s : `#${s}`))
    },
  },
}
</script>

<style scoped>
.article-card {
  padding: 16px;
  width: 260px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  cursor: pointer;
}

@media (min-width: 768px) {
  .article-card {
    width: auto;
  }
}

.article-card__title {
  font-size: 15px;
  font-weight: 700;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.article-card__excerpt {
  font-size: 12px;
  color: var(--color-text-secondary);
  line-height: 1.7;
  flex: 1;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.article-card__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: auto;
}

.article-card__hashtag {
  font-size: 12px;
  color: var(--color-text-light);
}
</style>
